<template>
    <div id="detalhamento-analise">
        <BaseHeader
            :titulo="
                dadosCertificacao.dadosTerritorio[0].nomeTerritorio.toUpperCase()
            "
            icon="el-icon-download"
            :btnTexto="$tc('certification.messages.export_report')"
            @btnHeaderClicado="handleBtnHeaderClicado"
            :componenteAuxiliarBotaoHeader="'DropdownOptionsExportarRelatorio'"
            :showComponenteAuxiliar="showComponenteAuxiliar"
            :exibeBotao="true"
            voltarPara="emit"
            @voltarClicado="goToGestaoCertificacao()"
        />
        <div class="view-container margen-bottom-pages">
            <div class="bloco-conteudo">
                <BlocoDadosCertificacao
                    :dadosCertificacao="dadosCertificacao"
                />
            </div>
            <div class="bloco-certificacao-territorio">
                <BlocoCertificacaoTerritorio
                    :dadosCertificacao="dadosCertificacao"
                />
            </div>
            <div class="bloco-status-tipo-certificacao">
                <BlocoStatusCertificacoes
                    :dadosCertificacao="dadosCertificacao"
                />
            </div>
            <div class="bloco-conteudo">
                <BlocoDadosAreaPlantio :dadosAreaPlantio="dadosAreaPlantio" />
            </div>
            <div class="bloco-conteudo">
                <BlocoDadosCar
                    :dadosTerritorio="dadosTerritorio || {}"
                    :arquivosCertificacao="
                        dadosCertificacao?.consolidadoTerritorio
                            ?.arquivosCertificacaoTerritorio || []
                    "
                    :dadosCertificacao="dadosCertificacao"
                />
            </div>
            <div class="bloco-conteudo">
                <HistoricoCertificacao
                    :idAnalise="dadosCertificacao.id"
                    :historico="
                        dadosCertificacao.resumoHistoricoCertificacaoTerritorio
                    "
                    @atualizar="atualizarDadosPorHistorico"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoDadosCertificacao from '@/modules/certification/views/pages/detail/components/BlocoDadosCertificacao.vue';
import BlocoStatusCertificacoes from '@/modules/certification/views/pages/detail/components/BlocoStatusCertificacoes.vue';
import BlocoDadosAreaPlantio from '@/modules/certification/views/pages/detail/components/BlocoDadosAreaPlantio.vue';
import CertificacaoService from '@/services/CertificacaoService.js';
import BlocoDadosCar from '@/modules/certification/views/pages/detail/components/BlocoDadosCar.vue';
import BlocoCertificacaoTerritorio from '@/modules/certification/views/pages/detail/components/BlocoCertificacaoTerritorio.vue';
import HistoricoCertificacao from '@/modules/certification/views/pages/detail/components/HistoricoCertificacao.vue';

export default {
    name: 'DetalhamentoAnalise',
    components: {
        BaseHeader,
        BlocoDadosCertificacao,
        BlocoStatusCertificacoes,
        BlocoDadosCar,
        BlocoDadosAreaPlantio,
        BlocoCertificacaoTerritorio,
        HistoricoCertificacao
    },
    data() {
        return {
            dadosCertificacao: {
                id: null,
                dataAnalise: '',
                dadosTerritorio: [
                    {
                        nomeTerritorio: '',
                        municipioTerritorioNome: '',
                        estadoTerritorioSigla: ''
                    }
                ],
                representantes: [],
                cars: [],
                certificacaoTerritorioResultado: [],
                resumoHistoricoCertificacaoTerritorio: []
            },
            dadosTerritorio: null,
            dadosAreaPlantio: {},
            showComponenteAuxiliar: false,
            idCertificacao: null
        };
    },
    async mounted() {
        this.idCertificacao = this.$route.params.idCertificacao;
        await this.buscarDadosAreaPlantio();

        await this.buscarDadosAnalise();
        this.buscarDadosTerritorio();
    },
    methods: {
        atualizarDadosPorHistorico(idAnalise) {
            if (this.idCertificacao !== idAnalise) {
                const currentPath = this.$route.path;
                const newPath = currentPath.replace(/\d+$/, idAnalise);
                const idCertificacao = Number(idAnalise);

                this.$router.replace({
                    name: this.$route.name,
                    params: {
                        ...this.$route.params,
                        path: newPath,
                        idCertificacao
                    }
                });
                this.idCertificacao = idCertificacao;
                this.buscarDadosAnalise().then(() => {
                    document
                        .getElementById('base-header')
                        .scrollIntoView({ behavior: 'smooth' });
                });
            }
        },
        async buscarDadosAnalise() {
            try {
                const { data } =
                    await CertificacaoService.buscarDadosDetalhamentoAnalise(
                        this.idCertificacao
                    );

                this.dadosCertificacao = { ...data.itens[0] };
            } catch (error) {}
        },
        goToGestaoCertificacao() {
            this.$router.push({ name: 'Certificacao' });
        },
        async buscarDadosTerritorio() {
            if (this.dadosCertificacao && this.dadosCertificacao.id) {
                try {
                    const { data } =
                        await CertificacaoService.buscarDadosTerritorio(
                            this.dadosCertificacao.id
                        );
                    this.dadosTerritorio = data;
                } catch {
                    this.$notify.error(
                        'Ocorreu um erro ao buscar os dados do território.'
                    );
                }
            }
        },
        async buscarDadosAreaPlantio() {
            let idCertificacao = this.$route.params.idCertificacao;
            try {
                const { data } =
                    await CertificacaoService.buscarDadosAreaPlantio(
                        idCertificacao
                    );
                this.dadosAreaPlantio = { ...data };
            } catch (error) {}
        },
        handleBtnHeaderClicado() {
            this.showComponenteAuxiliar = !this.showComponenteAuxiliar;
        }
    }
};
</script>

<style lang="scss" scoped>
#detalhamento-analise {
    .view-container.margen-bottom-pages {
        display: flex;
        flex-direction: column;

        .bloco-conteudo {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
        }
    }
    .bloco-status-tipo-certificacao {
        margin-top: 20px;
    }
}
</style>
